<script>
export default {
  data() {
    return {};
  },
  methods: {
    submitForm() {
      this.$router.push("/provider/provider-earnings");
    },
  },
};
</script>
<template>
  <!-- Delete Staff -->
  <div class="modal fade custom-modal" id="del-earning">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Earnings</h5>
          <a href="#" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <div class="modal-body">
          <div class="write-review">
            <form @submit.prevent="submitForm">
              <p>Are you sure want to delete this Earning?</p>
              <div class="modal-submit text-end">
                <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal">Cancel</a>
                <button type="submit" class="btn btn-dark">Yes</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Staff -->
</template>
